import styles from "./FormField.module.css";

export function FieldError({ id, message }: { id: string; message?: string }) {
  if (!message) return null;
  return (
    <p id={id} className={styles.errorText} role="alert">
      <span aria-hidden="true">⚠</span> {message}
    </p>
  );
}
